export class LocationModel {
  type: string;
  coordinates?: number[] | null;
}
